export const INACTIVITY_TIMEOUT = 15 * 60 * 1000;
export const STORAGE_KEY = 'anamnesis_data';
export const TIMESTAMP_KEY = 'anamnesis_timestamp';

export function createEmptyForm() {
  return {
    initial: { selections: [], freeText: '' },
    abcde: {
      airway: { abnormalities: [] },
      breathing: { abnormalities: [] },
      circulation: { abnormalities: [], ekg: [] },
      disability: { abnormalities: [] },
      exposure: { abnormalities: [] }
    },
    sampler: {
      symptoms: [], allergies: [], medications: [], history: [],
      lastMeal: '', event: [], riskFactors: [], weight: ''
    },
    stu: { enabled: false, findings: [] },
    measures: {
      measures: [], oxygen_flow: '', medication_details: '',
      wound_details: '', splint_details: '', additional_measures: ''
    },
    additional: { ivAccess: false, transportRefusal: false, ambulatoryCare: false }
  };
}

const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

function mergeForm(defaults, saved) {
  if (!isObject(saved)) return defaults;
  const result = { ...saved };
  Object.entries(defaults).forEach(([key, fallback]) => {
    if (isObject(fallback)) result[key] = mergeForm(fallback, saved[key]);
    else if (Array.isArray(fallback)) result[key] = Array.isArray(saved[key]) ? saved[key] : fallback;
    else result[key] = saved[key] ?? fallback;
  });
  return result;
}

// Lazy initialization avoids overwriting the saved form during mount/StrictMode.
export function loadSavedForm(storage = localStorage, now = Date.now()) {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    const timestamp = Number(storage.getItem(TIMESTAMP_KEY));
    if (raw && timestamp > 0 && now - timestamp >= 0 && now - timestamp < INACTIVITY_TIMEOUT) {
      return mergeForm(createEmptyForm(), JSON.parse(raw));
    }
  } catch {
    // Malformed or inaccessible browser storage must not break the form.
  }
  return createEmptyForm();
}